export const createGenerator = () => {
  let current = 0
  return {
    generate : () => {
      return ".F"+(++current)
    },
    reset : () =>{current = 0}
  }
}
